import React from 'react';
import { useFormikContext } from 'formik';
import { Input, RadioGroup, Section } from '../Shared';
import { CITING_SECTION_TITLE } from './constants';
import { SourceFromOptions, REVIEW_TITLE_INPUT_TEST_ID, REVIEW_MEDIUM_INPUT_TEST_ID, SOURCE_REVIEWED_INPUT_TEST_ID } from '../../forms/review/constants';

/** review citing section id and testId */
export var SECTION_ID = 'review-citing-section';
export var SECTION_TEST_ID = 'review-citing-section-test-id';

/** review input ids */
export var REVIEW_TITLE_INPUT_LABEL = 'Review title';
export var REVIEW_MEDIUM_INPUT_LABEL = 'Review medium';
export var REVIEW_MEDIUM_INPUT_HELPER_TEXT = 'Ex: the movie, the book';
export var SOURCE_REVIEWED_INPUT_LABEL = 'Source reviewed';
export var SOURCE_REVIEWED_INPUT_HELPER_TEXT = 'What was the original source that was reviewed?';

/** radio group options title and testIds */
export var SOURCE_FROM_RADIO_INPUT_TITLE = 'Source from';
export var SOURCE_FROM_RADIO_INPUT_TEST_ID = 'source-from-radio-input-test-id';
export var ReviewCitingSection = function ReviewCitingSection(_ref) {
  var selectedTab = _ref.selectedTab;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  var sourceFromRadioGroupOnChangeHandler = function sourceFromRadioGroupOnChangeHandler(options) {
    setFieldValue('pubtype.main', options.key);
  };
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(SECTION_ID, "-label"),
    dataTestId: SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    options: SourceFromOptions,
    legend: SOURCE_FROM_RADIO_INPUT_TITLE,
    name: "".concat(selectedTab, ".pubtype.main"),
    formikFieldName: "pubtype.main",
    align: "horizontal",
    "data-test": SOURCE_FROM_RADIO_INPUT_TEST_ID,
    onChange: sourceFromRadioGroupOnChangeHandler
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "review.title",
    labelText: REVIEW_TITLE_INPUT_LABEL,
    "data-test": REVIEW_TITLE_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "review.reviewtype",
    labelText: REVIEW_MEDIUM_INPUT_LABEL,
    helperText: REVIEW_MEDIUM_INPUT_HELPER_TEXT,
    "data-test": REVIEW_MEDIUM_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "review.reviewedpub",
    labelText: SOURCE_REVIEWED_INPUT_LABEL,
    helperText: SOURCE_REVIEWED_INPUT_HELPER_TEXT,
    "data-test": SOURCE_REVIEWED_INPUT_TEST_ID
  }));
};